import React from 'react';
import {back, closeModal} from '../../../../assets/images/images';
import {PrimaryButton} from '../../../../components';
import {X} from 'lucide-react';

export const ModalHeader = ({
  logo,
  lookupType,
  setOpen,
  changeLookupPage,
  clearLookupDetails,
  downloadPDF,
  content,
}) => (
  <>
    <div className="hidden print:flex print:items-center print:justify-between">
      <img src={logo} alt="" style={{maxHeight: '40px'}} />
      <h3 className="text-grey text-base font-medium">
        {lookupType?.label} verification
      </h3>
    </div>
    <button
      onClick={() => {
        setOpen(false);
        changeLookupPage(1);
      }}
      className="flex items-center gap-2 sm:hidden bg-white80 p-2 pl-0 print:hidden"
    >
      <img src={back} alt="" />
      <span className="text-small text-grey80 font-medium">
        Back to Easy Lookup
      </span>
    </button>
    <header className="mt-6 sm:mt-0 px-6 py-3 border-transparent border-[0.5px] border-b-[#E4E4E6] flex items-center justify-between flex-wrap sm:flex-nowrap print:hidden">
      <div className="flex items-center gap-2 flex-col sm:flex-row">
        <h3 className="text-deepBlue text-base font-semibold">
          {lookupType?.label} verification
        </h3>
        <div className="flex items-center gap-2">
          <div className="uppercase py-1 px-2 text-xs text-success20 font-medium bg-success rounded-full w-fit">
            completed
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4 mt-4 sm:mt-0">
        <PrimaryButton
          buttonText="Download PDF"
          className="w-full sm:w-auto sm:max-w-xs"
          onClick={downloadPDF}
          disabled={!content}
        />
        <button
          onClick={() => {
            setOpen(false);
            setTimeout(() => {
              changeLookupPage(1);
              clearLookupDetails();
            }, 1000);
          }}
          className="bg-[#EDEDED] hidden sm:block rounded-md p-1.5"
        >
          <X size={16} color="#242424" />
        </button>
      </div>
    </header>
  </>
);
